import { Component, EventEmitter, Input, Output, Inject, OnInit } from '@angular/core';
import { to64encode } from 'src/app/helpers/base64';
import { sortArrayOfObjects } from 'src/app/helpers/sortArrayOfObjects';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CorporationService } from 'src/app/services/corporation/corporation.service';
import { UserEnvironmentsService } from 'src/app/services/userEnvironments/user-environments.service';
import { UsersService } from 'src/app/services/users/users.service';
import { getLanguageCookie } from 'src/assets/language';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { LocalStorageService } from '../../../services/local-storage/local-storage.service';
@Component({
  selector: 'app-general-settings',
  templateUrl: './configurations.component.html',
  styleUrls: ['./configurations.component.scss']
})
export class GeneralSettingsComponent implements OnInit {  

  @Input() properties: any
  @Output() toggleConfigurations: EventEmitter<any> = new EventEmitter<any>();
  @Output() chooseEnvironment: EventEmitter<any> = new EventEmitter<any>();

  selectedLanguage: any 
  languageArray: any = [
    { lang: 'en', file: 'us.svg'},
    { lang: 'pt', file: 'br.svg'}
  ]

  searchEnvironment: string = ''
  environmentArray: any = []
  backupEnvironment: any
  selectedEnvironment: any = {}

  selectedCorporation: any
  searchCorporation: string = ''
  corporationArray: any = []
  backupCorporationCookie: any
  corporationAccess: any = []
  constructor(
    private corporationService: CorporationService,
    private userService: UsersService,
    private authService: AuthService,
    private userEnvironmentService: UserEnvironmentsService,
    private navigationService: NavigationService,
    @Inject('apiOfflineAsync') private apiOfflineAsync: any,
    private localStorageService: LocalStorageService,
  ){}

  async ngOnInit(){
    await this.getMe()
    await this.getUserCorporations()
    this.selectedLanguage = this.properties.language.lang
    this.selectedEnvironment = this.properties.environment
    this.backupEnvironment = this.properties.environment
    this.properties.users_environments.environments.forEach((item: any)=> {
      if(item.uuid == this.selectedEnvironment.uuid && item.favorite_corporation){
        this.selectedCorporation = item.favorite_corporation
      }
    })
    this.backupCorporationCookie = this.properties.corporation
    this.environmentArray = sortArrayOfObjects(this.properties.users_environments.environments)
    // this.corporationArray = this.properties.users_corporations.corporations
  }

  getLanguages(file: string){
    return getLanguageCookie(file, localStorage.getItem('language'))
  }

  conclude(){
    let flag: boolean = false
    
    if(this.selectedEnvironment != this.backupEnvironment){
      flag = true
    }else{
      this.properties.corporation = this.backupCorporationCookie
    }

    this.userService.setUserMe(this.properties)
    localStorage.setItem('language', to64encode(this.properties.language))

    this.exitModal(flag)
  }

  exitModal(flag: boolean = false){
    if(flag){
      Promise.all([
        this.toggleConfigurations.emit(),
        this.chooseEnvironment.emit(this.selectedEnvironment)
      ])
      return 
    }
    this.toggleConfigurations.emit()
  }

  async getMe() {
    try {
      const response = await this.authService.getMe();
      const localStorageData = await this.localStorageService.localStorageToJsonAsync(true);
      this.properties = { ...response.data, ...localStorageData }
    } catch (error: any) {
      await this.apiOfflineAsync(error)
    }
  }

  async choseItemSelect(type: string, value: any){
    switch (type) {
      case 'language':
        this.selectedLanguage = value.lang;
        this.properties.language = value
        break;
      case 'environment':
        this.selectedEnvironment = value;
        this.properties.environment = value
        await this.getUserCorporations()
        delete this.selectedCorporation
        delete this.properties.corporation
        this.properties.users_environments.environments.forEach((item: any)=> {
          if(item.uuid == this.selectedEnvironment.uuid && item.favorite_corporation){
            this.selectedCorporation = item.favorite_corporation
            this.properties.corporation = item.favorite_corporation
            delete this.properties.corporation.url
          }
        })
        break
      case 'corporation':
        if (!value.access) {
          return
        }
        this.selectedCorporation = value;
        this.properties.users_environments.environments.forEach((item: any)=> {
          if(item.uuid == this.selectedEnvironment.uuid){
            item.favorite_corporation = this.selectedCorporation
            delete item.favorite_corporation.children 
            this.properties.corporation = item.favorite_corporation
          }
        })
        break;
      default:
        break;
    }
  }

  async getCorporations(){
    this.corporationService.getCorporationTree({ environment: this.selectedEnvironment }).subscribe(
      (response: any) => {
        if (response && response.data && response.data.result) {
          // this.corporationArray = sortArrayOfObjects(this.flattenArray(response.data.result));
          const flattened = this.flattenCorporationTree(response.data.result);
          this.corporationArray = flattened;
        }else {
          throw new Error('Erro ao consultar àrvore de corporations!\nConsulta o administrador do sistema!');
        }
      },
      (error) => {
        console.error(error);
      }
    )
  }

  async getUserCorporations(){
    try{
      let response = await this.userEnvironmentService.getUserCorporations()
      if(response && response.data){
        this.corporationAccess = response.data;
        await this.getCorporations()
      }
    }catch{

    }
  }

  flattenCorporationTree(tree: any[], level: number = 1, result: any[] = []): any[] {
    for (const corporation of tree) {
      const corporationClone = { ...corporation, __level: level };
  
      if (this.properties.me.is_admin_master || this.corporationAccess.some((access: any) => access.uuid == corporationClone.uuid)) {
        corporationClone.access = true;
      } else {
        corporationClone.access = false;
      }
          
      result.push({ uuid: corporationClone.uuid, name: corporationClone.name, level: level, access: corporationClone.access, slug: corporationClone.slug });
  
      if (corporation.children && corporation.children.length > 0) {
        this.flattenCorporationTree(corporation.children, level + 1, result);
      }
    }
    return result;
  }


  flattenArray(data: any[]): any[] {
    let flatArray: any[] = [];
    data.forEach(item => {
      if(this.properties.users_corporations.ids.includes(item.uuid)){
        flatArray.push(item);
      // }else if(this.properties.me.is_admin != 'OTHERS'){
      }else if(!this.properties.me.is_admin_master){
        flatArray.push(item);
      }

      if (item.children && item.children.length > 0) {
        flatArray = flatArray.concat(this.flattenArray(item.children));
      }
    });
  
    return flatArray;
  }

}
